var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3792 32.0518C25.0066 32.0518 32.0005 25.0981 32.0005 16.5203C32.0005 7.94246 25.0066 0.98877 16.3792 0.98877C7.75173 0.98877 0.757812 7.94246 0.757812 16.5203C0.757812 25.0981 7.75173 32.0518 16.3792 32.0518Z",
    stroke: "#B7B7B7",
    strokeWidth: 0.625
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_554_1720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.721 11.8628H14.0346C12.7405 11.8628 11.6914 12.9058 11.6914 14.1925V18.852C11.6914 20.1386 12.7405 21.1817 14.0346 21.1817H18.721C20.0151 21.1817 21.0642 20.1386 21.0642 18.852V14.1925C21.0642 12.9058 20.0151 11.8628 18.721 11.8628Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2523 16.2291C18.3101 16.6168 18.2435 17.0129 18.0619 17.3609C17.8803 17.7088 17.593 17.991 17.2408 18.1672C16.8886 18.3435 16.4895 18.4048 16.1002 18.3426C15.7109 18.2803 15.3513 18.0975 15.0725 17.8203C14.7937 17.5431 14.6099 17.1856 14.5472 16.7986C14.4846 16.4115 14.5463 16.0147 14.7236 15.6645C14.9008 15.3144 15.1847 15.0287 15.5346 14.8481C15.8846 14.6676 16.2829 14.6013 16.673 14.6588C17.0708 14.7175 17.4391 14.9018 17.7235 15.1846C18.0079 15.4673 18.1933 15.8335 18.2523 16.2291Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.957,
    cy: 13.9582,
    rx: 0.703126,
    ry: 0.698918,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_554_1720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2474,
    height: 11.1827,
    fill: "white",
    transform: "translate(10.7539 10.9302)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.a72597fb3df5e9232d6668194ec82485.svg";
export { ForwardRef as ReactComponent };